(function() {
  const writeReviewBtn = document.getElementById('write-review-button');
  const modal = document.getElementById('review-modal');
  const modalClose = document.getElementById('modal-close');
  const modalOverlay = modal?.querySelector('.modal-overlay');
  const starRating = document.getElementById('star-rating');
  const reviewForm = document.getElementById('review-form');
  
  let selectedRating = 0;
  
  // Open modal - Modified to click Judge.me button and open custom modal
  writeReviewBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Find and click Judge.me button
    const judgeReviewButton = document.querySelector('.jdgm-widget-actions-wrapper .jdgm-write-rev-link');
    
    if (judgeReviewButton) {
      judgeReviewButton.click();
    }
    
    // Always open custom modal as well
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden'; // Also for html element
    
    // Prevent document scroll
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  });
  
  // Close modal
  function closeModal() {
    modal.style.display = 'none';
    
    // Restore scroll
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    
    // Restore scroll position
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }
  
  modalClose?.addEventListener('click', closeModal);
  modalOverlay?.addEventListener('click', closeModal);
  
  // Star rating functionality
  if (starRating) {
    const stars = starRating.querySelectorAll('.star');
    
    stars.forEach((star, index) => {
      star.addEventListener('click', function() {
        selectedRating = index + 1;
        updateStars();
      });
      
      star.addEventListener('mouseenter', function() {
        highlightStars(index + 1);
      });
    });
    
    starRating.addEventListener('mouseleave', function() {
      updateStars();
    });
    
    function highlightStars(rating) {
      stars.forEach((star, index) => {
        if (index < rating) {
          star.classList.add('active');
        } else {
          star.classList.remove('active');
        }
      });
    }
    
    function updateStars() {
      stars.forEach((star, index) => {
        if (index < selectedRating) {
          star.classList.add('filled');
        } else {
          star.classList.remove('filled');
        }
      });
    }
  }
  
  // Form submission
  reviewForm?.addEventListener('submit', function(e) {
    e.preventDefault();
    
    if (selectedRating === 0) {
      alert('Please select a rating');
      return;
    }
    
    // Get review title value from custom form
    const reviewTitleValue = document.getElementById('review-title').value;
    
    // Set title value in Judge.me widget form
    const judgeReviewTitleField = document.querySelector('[name="review_title"]');
    if (judgeReviewTitleField) {
      judgeReviewTitleField.value = reviewTitleValue;
    }
    
    // Get review text value from custom form
    const reviewTextValue = document.getElementById('review-text').value;
    
    // Set review body value in Judge.me widget form
    const judgeReviewBodyField = document.querySelector('[name="review_body"]');
    if (judgeReviewBodyField) {
      judgeReviewBodyField.value = reviewTextValue;
    }
    
    // Get full name value from custom form
    const fullNameValue = document.getElementById('full-name').value;
    
    // Set reviewer name value in Judge.me widget form
    const judgeReviewerNameField = document.querySelector('[name="reviewer_name"]');
    if (judgeReviewerNameField) {
      judgeReviewerNameField.value = fullNameValue;
    }
    
    // Get email value from custom form
    const emailValue = document.getElementById('email').value;
    
    // Set reviewer email value in Judge.me widget form
    const judgeReviewerEmailField = document.querySelector('[name="reviewer_email"]');
    if (judgeReviewerEmailField) {
      judgeReviewerEmailField.value = emailValue;
    }
    
    // Get selected star rating from custom form
    const customStars = document.querySelectorAll('#star-rating .star.filled');
    const customRating = customStars.length || selectedRating;
    
    // Apply rating to Judge.me widget stars
    const judgeStars = document.querySelectorAll('.jdgm-form__rating .jdgm-star');
    if (judgeStars.length > 0) {
      // First, reset all stars
      judgeStars.forEach((star, index) => {
        star.classList.remove('jdgm--on');
        star.classList.add('jdgm--off');
        
        // Activate stars according to rating
        if (index < customRating) {
          star.classList.remove('jdgm--off');
          star.classList.add('jdgm--on');
          // Simulate click on corresponding star
          star.click();
        }
      });
    }
    
    // Wait a moment to ensure all fields are updated then submit
    setTimeout(() => {
      // Find Judge.me submit button with different possible selectors
      let judgeSubmitButton = document.querySelector('.jdgm-submit-rev.btn.btn_c.button');
      
      // If not found, try other selectors
      if (!judgeSubmitButton) {
        judgeSubmitButton = document.querySelector('.jdgm-submit-rev');
      }
      if (!judgeSubmitButton) {
        judgeSubmitButton = document.querySelector('button[type="submit"].jdgm-submit-rev');
      }
      if (!judgeSubmitButton) {
        judgeSubmitButton = document.querySelector('input[type="submit"].jdgm-submit-rev');
      }
      
      if (judgeSubmitButton) {
        
        // Try different click methods
        judgeSubmitButton.click();
        
        // Also try to dispatch submit event on form
        const judgeForm = judgeSubmitButton.closest('form');
        if (judgeForm) {
          // Dispatch submit event as well
          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          judgeForm.dispatchEvent(submitEvent);
        }
        
        // Close custom modal after submitting
        setTimeout(() => {
          closeModal();
          reviewForm.reset();
          selectedRating = 0;
          updateStars();
        }, 1500);
      } else {
        alert('Error: Could not submit review');
      }
    }, 500); // Wait 500ms for all fields to update
    
  });
  
  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });
})();
